import Teams from "./collection";

export default class SessionTeams extends Teams {

    constructor(teams: any[] = []) {
        super(teams)
    }

    // Session-specific methods can be added here
    // For example, methods that work with the current session context

} 